import { render, staticRenderFns } from "./setSize.vue?vue&type=template&id=3dfbe152&scoped=true&"
import script from "./setSize.vue?vue&type=script&lang=js&"
export * from "./setSize.vue?vue&type=script&lang=js&"
import style0 from "./setSize.vue?vue&type=style&index=0&id=3dfbe152&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfbe152",
  null
  
)

export default component.exports